var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScenariosIntroduction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 644,
    height: 521,
    viewBox: "0 0 644 521",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M572.861 270.744C569.767 272.531 565.954 272.531 562.859 270.744L504 236.752L496.721 240.954C494.721 242.109 494.721 244.996 496.721 246.15L562.86 284.336C565.954 286.122 569.766 286.122 572.86 284.336L639 246.15C641 244.996 641 242.109 639 240.954L631.72 236.752L572.861 270.744Z",
    fill: "#CFD2D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M567.86 186.282L496.72 227.364C494.72 228.519 494.72 231.405 496.72 232.56L562.86 270.746C565.954 272.532 569.766 272.532 572.86 270.746L639.001 232.56C641.001 231.405 641.001 228.519 639.001 227.364L567.86 186.282Z",
    fill: "url(#paint0_linear_1_692)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M495.92 232.32L562.864 270.763C565.957 272.539 569.761 272.534 572.848 270.749L639.334 232.32",
    stroke: "#083B4A",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M599.95 218.682C592.54 229.442 580.1 236.512 565.99 236.512C551.88 236.512 539.43 229.442 532.03 218.682C527.59 222.482 525 227.062 525 231.992C525 245.122 543.35 255.762 565.99 255.762C588.63 255.762 606.98 245.122 606.98 231.992C606.98 227.062 604.39 222.482 599.95 218.682Z",
    fill: "#083B4A",
    fillOpacity: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M567.86 226.012C568.247 226.012 568.56 225.699 568.56 225.312C568.56 224.926 568.247 224.612 567.86 224.612C567.474 224.612 567.16 224.926 567.16 225.312C567.16 225.699 567.474 226.012 567.86 226.012Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.9 230.662C576.287 230.662 576.6 230.349 576.6 229.962C576.6 229.576 576.287 229.262 575.9 229.262C575.514 229.262 575.2 229.576 575.2 229.962C575.2 230.349 575.514 230.662 575.9 230.662Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.86 235.302C568.247 235.302 568.56 234.989 568.56 234.602C568.56 234.216 568.247 233.902 567.86 233.902C567.474 233.902 567.16 234.216 567.16 234.602C567.16 234.989 567.474 235.302 567.86 235.302Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.94 235.302C584.327 235.302 584.64 234.989 584.64 234.602C584.64 234.216 584.327 233.902 583.94 233.902C583.554 233.902 583.24 234.216 583.24 234.602C583.24 234.989 583.554 235.302 583.94 235.302Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.9 239.942C576.287 239.942 576.6 239.629 576.6 239.242C576.6 238.856 576.287 238.542 575.9 238.542C575.514 238.542 575.2 238.856 575.2 239.242C575.2 239.629 575.514 239.942 575.9 239.942Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.86 244.582C568.247 244.582 568.56 244.269 568.56 243.882C568.56 243.496 568.247 243.182 567.86 243.182C567.474 243.182 567.16 243.496 567.16 243.882C567.16 244.269 567.474 244.582 567.86 244.582Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.98 239.942C592.367 239.942 592.68 239.629 592.68 239.242C592.68 238.856 592.367 238.542 591.98 238.542C591.594 238.542 591.28 238.856 591.28 239.242C591.28 239.629 591.594 239.942 591.98 239.942Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.94 244.582C584.327 244.582 584.64 244.269 584.64 243.882C584.64 243.496 584.327 243.182 583.94 243.182C583.554 243.182 583.24 243.496 583.24 243.882C583.24 244.269 583.554 244.582 583.94 244.582Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.9 249.232C576.287 249.232 576.6 248.919 576.6 248.532C576.6 248.146 576.287 247.832 575.9 247.832C575.514 247.832 575.2 248.146 575.2 248.532C575.2 248.919 575.514 249.232 575.9 249.232Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.86 253.872C568.247 253.872 568.56 253.559 568.56 253.172C568.56 252.786 568.247 252.472 567.86 252.472C567.474 252.472 567.16 252.786 567.16 253.172C567.16 253.559 567.474 253.872 567.86 253.872Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.98 249.232C592.367 249.232 592.68 248.919 592.68 248.532C592.68 248.146 592.367 247.832 591.98 247.832C591.594 247.832 591.28 248.146 591.28 248.532C591.28 248.919 591.594 249.232 591.98 249.232Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.94 253.872C584.327 253.872 584.64 253.559 584.64 253.172C584.64 252.786 584.327 252.472 583.94 252.472C583.554 252.472 583.24 252.786 583.24 253.172C583.24 253.559 583.554 253.872 583.94 253.872Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.03 244.582C600.417 244.582 600.73 244.269 600.73 243.882C600.73 243.496 600.417 243.182 600.03 243.182C599.644 243.182 599.33 243.496 599.33 243.882C599.33 244.269 599.644 244.582 600.03 244.582Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.9 258.512C576.287 258.512 576.6 258.199 576.6 257.812C576.6 257.426 576.287 257.112 575.9 257.112C575.514 257.112 575.2 257.426 575.2 257.812C575.2 258.199 575.514 258.512 575.9 258.512Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.86 263.152C568.247 263.152 568.56 262.839 568.56 262.452C568.56 262.066 568.247 261.752 567.86 261.752C567.474 261.752 567.16 262.066 567.16 262.452C567.16 262.839 567.474 263.152 567.86 263.152Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.82 230.662C560.207 230.662 560.52 230.349 560.52 229.962C560.52 229.576 560.207 229.262 559.82 229.262C559.434 229.262 559.12 229.576 559.12 229.962C559.12 230.349 559.434 230.662 559.82 230.662Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.94 216.732C584.327 216.732 584.64 216.419 584.64 216.032C584.64 215.646 584.327 215.332 583.94 215.332C583.554 215.332 583.24 215.646 583.24 216.032C583.24 216.419 583.554 216.732 583.94 216.732Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.98 221.372C592.367 221.372 592.68 221.059 592.68 220.672C592.68 220.286 592.367 219.972 591.98 219.972C591.594 219.972 591.28 220.286 591.28 220.672C591.28 221.059 591.594 221.372 591.98 221.372Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.94 226.012C584.327 226.012 584.64 225.699 584.64 225.312C584.64 224.926 584.327 224.612 583.94 224.612C583.554 224.612 583.24 224.926 583.24 225.312C583.24 225.699 583.554 226.012 583.94 226.012Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.03 226.012C600.417 226.012 600.73 225.699 600.73 225.312C600.73 224.926 600.417 224.612 600.03 224.612C599.644 224.612 599.33 224.926 599.33 225.312C599.33 225.699 599.644 226.012 600.03 226.012Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.98 230.662C592.367 230.662 592.68 230.349 592.68 229.962C592.68 229.576 592.367 229.262 591.98 229.262C591.594 229.262 591.28 229.576 591.28 229.962C591.28 230.349 591.594 230.662 591.98 230.662Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.07 230.662C608.457 230.662 608.77 230.349 608.77 229.962C608.77 229.576 608.457 229.262 608.07 229.262C607.684 229.262 607.37 229.576 607.37 229.962C607.37 230.349 607.684 230.662 608.07 230.662Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.03 235.302C600.417 235.302 600.73 234.989 600.73 234.602C600.73 234.216 600.417 233.902 600.03 233.902C599.644 233.902 599.33 234.216 599.33 234.602C599.33 234.989 599.644 235.302 600.03 235.302Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.07 239.942C608.457 239.942 608.77 239.629 608.77 239.242C608.77 238.856 608.457 238.542 608.07 238.542C607.684 238.542 607.37 238.856 607.37 239.242C607.37 239.629 607.684 239.942 608.07 239.942Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.11 235.302C616.497 235.302 616.81 234.989 616.81 234.602C616.81 234.216 616.497 233.902 616.11 233.902C615.724 233.902 615.41 234.216 615.41 234.602C615.41 234.989 615.724 235.302 616.11 235.302Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.9 221.372C576.287 221.372 576.6 221.059 576.6 220.672C576.6 220.286 576.287 219.972 575.9 219.972C575.514 219.972 575.2 220.286 575.2 220.672C575.2 221.059 575.514 221.372 575.9 221.372Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.03 216.732C600.417 216.732 600.73 216.419 600.73 216.032C600.73 215.646 600.417 215.332 600.03 215.332C599.644 215.332 599.33 215.646 599.33 216.032C599.33 216.419 599.644 216.732 600.03 216.732Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.07 221.372C608.457 221.372 608.77 221.059 608.77 220.672C608.77 220.286 608.457 219.972 608.07 219.972C607.684 219.972 607.37 220.286 607.37 220.672C607.37 221.059 607.684 221.372 608.07 221.372Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.11 226.012C616.497 226.012 616.81 225.699 616.81 225.312C616.81 224.926 616.497 224.612 616.11 224.612C615.724 224.612 615.41 224.926 615.41 225.312C615.41 225.699 615.724 226.012 616.11 226.012Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.15 230.662C624.537 230.662 624.85 230.349 624.85 229.962C624.85 229.576 624.537 229.262 624.15 229.262C623.764 229.262 623.45 229.576 623.45 229.962C623.45 230.349 623.764 230.662 624.15 230.662Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.98 212.082C592.367 212.082 592.68 211.769 592.68 211.382C592.68 210.996 592.367 210.682 591.98 210.682C591.594 210.682 591.28 210.996 591.28 211.382C591.28 211.769 591.594 212.082 591.98 212.082Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.78 235.302C552.167 235.302 552.48 234.989 552.48 234.602C552.48 234.216 552.167 233.902 551.78 233.902C551.394 233.902 551.08 234.216 551.08 234.602C551.08 234.989 551.394 235.302 551.78 235.302Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.82 239.942C560.207 239.942 560.52 239.629 560.52 239.242C560.52 238.856 560.207 238.542 559.82 238.542C559.434 238.542 559.12 238.856 559.12 239.242C559.12 239.629 559.434 239.942 559.82 239.942Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.74 239.942C544.127 239.942 544.44 239.629 544.44 239.242C544.44 238.856 544.127 238.542 543.74 238.542C543.354 238.542 543.04 238.856 543.04 239.242C543.04 239.629 543.354 239.942 543.74 239.942Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.78 244.582C552.167 244.582 552.48 244.269 552.48 243.882C552.48 243.496 552.167 243.182 551.78 243.182C551.394 243.182 551.08 243.496 551.08 243.882C551.08 244.269 551.394 244.582 551.78 244.582Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.82 249.232C560.207 249.232 560.52 248.919 560.52 248.532C560.52 248.146 560.207 247.832 559.82 247.832C559.434 247.832 559.12 248.146 559.12 248.532C559.12 248.919 559.434 249.232 559.82 249.232Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.74 249.232C544.127 249.232 544.44 248.919 544.44 248.532C544.44 248.146 544.127 247.832 543.74 247.832C543.354 247.832 543.04 248.146 543.04 248.532C543.04 248.919 543.354 249.232 543.74 249.232Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.78 253.872C552.167 253.872 552.48 253.559 552.48 253.172C552.48 252.786 552.167 252.472 551.78 252.472C551.394 252.472 551.08 252.786 551.08 253.172C551.08 253.559 551.394 253.872 551.78 253.872Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.69 244.582C536.077 244.582 536.39 244.269 536.39 243.882C536.39 243.496 536.077 243.182 535.69 243.182C535.304 243.182 534.99 243.496 534.99 243.882C534.99 244.269 535.304 244.582 535.69 244.582Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.82 258.512C560.207 258.512 560.52 258.199 560.52 257.812C560.52 257.426 560.207 257.112 559.82 257.112C559.434 257.112 559.12 257.426 559.12 257.812C559.12 258.199 559.434 258.512 559.82 258.512Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.74 230.662C544.127 230.662 544.44 230.349 544.44 229.962C544.44 229.576 544.127 229.262 543.74 229.262C543.354 229.262 543.04 229.576 543.04 229.962C543.04 230.349 543.354 230.662 543.74 230.662Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.69 235.302C536.077 235.302 536.39 234.989 536.39 234.602C536.39 234.216 536.077 233.902 535.69 233.902C535.304 233.902 534.99 234.216 534.99 234.602C534.99 234.989 535.304 235.302 535.69 235.302Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.82 221.372C560.207 221.372 560.52 221.059 560.52 220.672C560.52 220.286 560.207 219.972 559.82 219.972C559.434 219.972 559.12 220.286 559.12 220.672C559.12 221.059 559.434 221.372 559.82 221.372Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.78 226.012C552.167 226.012 552.48 225.699 552.48 225.312C552.48 224.926 552.167 224.612 551.78 224.612C551.394 224.612 551.08 224.926 551.08 225.312C551.08 225.699 551.394 226.012 551.78 226.012Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.86 216.732C568.247 216.732 568.56 216.419 568.56 216.032C568.56 215.646 568.247 215.332 567.86 215.332C567.474 215.332 567.16 215.646 567.16 216.032C567.16 216.419 567.474 216.732 567.86 216.732Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.65 239.942C528.037 239.942 528.35 239.629 528.35 239.242C528.35 238.856 528.037 238.542 527.65 238.542C527.264 238.542 526.95 238.856 526.95 239.242C526.95 239.629 527.264 239.942 527.65 239.942Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.74 212.082C544.127 212.082 544.44 211.769 544.44 211.382C544.44 210.996 544.127 210.682 543.74 210.682C543.354 210.682 543.04 210.996 543.04 211.382C543.04 211.769 543.354 212.082 543.74 212.082Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.69 216.732C536.077 216.732 536.39 216.419 536.39 216.032C536.39 215.646 536.077 215.332 535.69 215.332C535.304 215.332 534.99 215.646 534.99 216.032C534.99 216.419 535.304 216.732 535.69 216.732Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.65 221.372C528.037 221.372 528.35 221.059 528.35 220.672C528.35 220.286 528.037 219.972 527.65 219.972C527.264 219.972 526.95 220.286 526.95 220.672C526.95 221.059 527.264 221.372 527.65 221.372Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.61 226.012C519.997 226.012 520.31 225.699 520.31 225.312C520.31 224.926 519.997 224.612 519.61 224.612C519.224 224.612 518.91 224.926 518.91 225.312C518.91 225.699 519.224 226.012 519.61 226.012Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.74 221.372C544.127 221.372 544.44 221.059 544.44 220.672C544.44 220.286 544.127 219.972 543.74 219.972C543.354 219.972 543.04 220.286 543.04 220.672C543.04 221.059 543.354 221.372 543.74 221.372Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.69 226.012C536.077 226.012 536.39 225.699 536.39 225.312C536.39 224.926 536.077 224.612 535.69 224.612C535.304 224.612 534.99 224.926 534.99 225.312C534.99 225.699 535.304 226.012 535.69 226.012Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.78 216.732C552.167 216.732 552.48 216.419 552.48 216.032C552.48 215.646 552.167 215.332 551.78 215.332C551.394 215.332 551.08 215.646 551.08 216.032C551.08 216.419 551.394 216.732 551.78 216.732Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.65 230.662C528.037 230.662 528.35 230.349 528.35 229.962C528.35 229.576 528.037 229.262 527.65 229.262C527.264 229.262 526.95 229.576 526.95 229.962C526.95 230.349 527.264 230.662 527.65 230.662Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.61 235.302C519.997 235.302 520.31 234.989 520.31 234.602C520.31 234.216 519.997 233.902 519.61 233.902C519.224 233.902 518.91 234.216 518.91 234.602C518.91 234.989 519.224 235.302 519.61 235.302Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.9 212.082C576.287 212.082 576.6 211.769 576.6 211.382C576.6 210.996 576.287 210.682 575.9 210.682C575.514 210.682 575.2 210.996 575.2 211.382C575.2 211.769 575.514 212.082 575.9 212.082Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.82 202.802C560.207 202.802 560.52 202.489 560.52 202.102C560.52 201.716 560.207 201.402 559.82 201.402C559.434 201.402 559.12 201.716 559.12 202.102C559.12 202.489 559.434 202.802 559.82 202.802Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.78 207.442C552.167 207.442 552.48 207.129 552.48 206.742C552.48 206.356 552.167 206.042 551.78 206.042C551.394 206.042 551.08 206.356 551.08 206.742C551.08 207.129 551.394 207.442 551.78 207.442Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.82 212.082C560.207 212.082 560.52 211.769 560.52 211.382C560.52 210.996 560.207 210.682 559.82 210.682C559.434 210.682 559.12 210.996 559.12 211.382C559.12 211.769 559.434 212.082 559.82 212.082Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.86 207.442C568.247 207.442 568.56 207.129 568.56 206.742C568.56 206.356 568.247 206.042 567.86 206.042C567.474 206.042 567.16 206.356 567.16 206.742C567.16 207.129 567.474 207.442 567.86 207.442Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.94 207.442C584.327 207.442 584.64 207.129 584.64 206.742C584.64 206.356 584.327 206.042 583.94 206.042C583.554 206.042 583.24 206.356 583.24 206.742C583.24 207.129 583.554 207.442 583.94 207.442Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.86 198.162C568.247 198.162 568.56 197.849 568.56 197.462C568.56 197.076 568.247 196.762 567.86 196.762C567.474 196.762 567.16 197.076 567.16 197.462C567.16 197.849 567.474 198.162 567.86 198.162Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.9 202.802C576.287 202.802 576.6 202.489 576.6 202.102C576.6 201.716 576.287 201.402 575.9 201.402C575.514 201.402 575.2 201.716 575.2 202.102C575.2 202.489 575.514 202.802 575.9 202.802Z",
    fill: "#040919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.57 230.662C511.957 230.662 512.27 230.349 512.27 229.962C512.27 229.576 511.957 229.262 511.57 229.262C511.184 229.262 510.87 229.576 510.87 229.962C510.87 230.349 511.184 230.662 511.57 230.662Z",
    fill: "#040919"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M565.91 236.492C588.62 236.492 607.03 218.194 607.03 195.622C607.03 173.05 588.62 154.752 565.91 154.752C543.2 154.752 524.79 173.05 524.79 195.622C524.79 218.194 543.2 236.492 565.91 236.492Z",
    fill: "#083B4A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M559.94 235.462L562.95 234.572L565.34 231.762L562.34 229.802L557.48 228.122L556.96 227.262L550.65 222.712L545.98 220.352L542.71 220.742L540.17 218.212L538.39 214.492L538.1 210.792L536.76 210.482L534.6 210.022L533.71 205.942L536.33 203.382L541.27 208.662L541.9 206.722L542.75 203.892L548.12 198.022L552.38 197.832L549.94 194.262L554.62 193.762L554.66 191.892C554.66 191.892 551.85 184.792 551.13 184.502C550.41 184.212 549.61 184.102 549.61 184.102L545.78 189.922L543.93 183.252L544.69 181.912L550.68 179.732L549.33 176.842L546.91 177.332L544.63 175.552L543.02 169.832C543.02 169.832 543.24 165.462 543.66 165.912C544.08 166.362 541.91 165.452 541.91 165.452L535.16 171.872L537.43 173.282L536.23 176.752L533.31 183.822L529.99 191.962L529.82 199.632L532.75 209.612L537.99 216.052L543.31 224.082L542.98 226.942L547.28 229.952L552.01 234.052L556.56 235.432H559.95L559.94 235.462Z",
    fill: "url(#paint1_linear_1_692)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M548.25 174.442L550.73 171.342L549.48 168.752L547.58 169.732L546.2 173.762L548.25 174.442Z",
    fill: "url(#paint2_linear_1_692)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M550.83 173.632L551.15 172.232L553.21 172.932L552.36 173.602L550.83 173.632Z",
    fill: "url(#paint3_linear_1_692)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M555.45 173.082L553.56 172.322L554.53 171.042L556.51 170.302L556.03 169.462L556.92 168.352L561.13 167.692L562.04 168.742L556.66 171.772L555.45 173.082Z",
    fill: "url(#paint4_linear_1_692)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M558.54 173.272C558.36 173.162 558.38 172.242 558.38 172.242L558.67 171.192L563.35 168.982L565.9 168.522L568.07 170.722L568.09 175.182L567.91 179.392L563.1 183.512L560.97 188.012L559.37 187.522L558.81 180.692L559.59 179.602L559.49 174.052L558.55 173.282L558.54 173.272Z",
    fill: "url(#paint5_linear_1_692)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M577.55 188.922L575.93 187.222L576.03 184.522L577.2 184.882L577.82 186.412L580.09 188.702V189.862L577.87 190.982L577.55 188.922Z",
    fill: "url(#paint6_linear_1_692)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M576.87 189.457L575.94 187.867L575.36 188.127L575.12 190.217L575.8 190.417L576.87 189.457Z",
    fill: "url(#paint7_linear_1_692)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M570.52 185.412L569.38 185.992L567.96 185.152L567.86 183.952L568.92 183.892L570.12 183.062L571.15 183.982L570.52 185.412Z",
    fill: "url(#paint8_linear_1_692)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M604.76 209.032L601.13 210.902L598.26 204.862L594.21 205.292L593.95 202.082L592.57 198.982L591.49 198.742L587.79 205.312L580.32 208.782L579.25 210.672L575.87 216.302L575.23 223.582L577.62 225.122L579.94 225.632L584.1 224.022L587.6 224.692L587.77 227.032L585.59 231.512C594.49 226.682 601.39 218.682 604.76 209.032Z",
    fill: "url(#paint9_linear_1_692)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M605.62 193.882L607.03 195.312C606.89 177.512 595.31 162.422 579.23 156.952L578.65 158.682L580.24 160.842L578.14 161.722L579.24 163.272L582.11 165.062L582.44 166.642L585.23 168.172L583.31 169.052C583.31 169.052 581.38 167.922 581.15 167.692C580.92 167.462 580.28 166.232 580.28 166.232L579.55 166.262L580.1 168.262L582.71 169.892L583.73 169.452L584.61 169.712L584.93 171.872L583.92 172.342L584.86 173.132L585.24 175.222L584.31 175.282C584.31 175.282 582.71 174.752 582.8 174.572C582.89 174.392 583.93 173.592 583.93 173.592L583.44 172.812L582.1 172.702L580.61 173.052L579.06 172.682L578.16 174.762L578.94 178.462L578.4 181.322L579.28 183.072L580.55 183.342L580.75 182.752H581.22L582.84 184.632L583.57 183.732L581.82 179.812L581.6 176.962L582.06 176.762L583.95 180.042L584.55 180.002L585.34 179.142L585.66 179.492L585.32 180.332L584.78 180.812L585.32 182.052L584.97 182.452L585.54 184.232L585.14 185.222L582.54 186.012L581.65 184.782L581.36 185.192L581.58 187.322L580.46 190.132L578.18 192.502L579.81 193.482L580.56 195.772L577.97 196.572L577.47 197.642C577.47 197.642 578.02 201.212 578.15 201.522C578.28 201.842 579.55 202.172 579.55 202.172C579.55 202.172 582.27 201.182 582.11 200.922C581.95 200.662 582.02 198.702 582.02 198.702C582.02 198.702 583.1 196.182 583.23 196.002C583.36 195.832 584.65 194.442 584.65 194.442H585.69L589.23 197.402L589.66 197.262L589.57 195.632L587 194.252L586.36 193.502L586.46 192.572L589.54 194.382L591.58 197.092L592.56 197.272L592.64 196.332L592.17 195.242L591.61 194.742L592.89 194.042L593.4 194.802L593.49 195.622L594.36 196.212L596.8 194.282L597.52 197.792L596.87 200.272L598.55 200.692L601.97 208.102L603.2 207.412L605.12 201.382L604.88 197.442L603.5 198.432L601.98 195.602L605.03 195.432L605.71 193.882H605.62Z",
    fill: "url(#paint10_linear_1_692)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M587.08 176.952L609.59 157.102",
    stroke: "#DF5F36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M533.69 188.832L516.18 185.152",
    stroke: "#DF5F36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M550.63 226.152L544.24 237.722",
    stroke: "#DF5F36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M547.81 234.812H539.83V242.792H547.81V234.812Z",
    fill: "url(#paint11_linear_1_692)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M544.54 190.512H536.56V198.492H544.54V190.512Z",
    fill: "url(#paint12_linear_1_692)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M552.52 182.532H544.54V190.512H552.52V182.532Z",
    fill: "#083B4A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M613.58 153.112H605.6V161.092H613.58V153.112Z",
    fill: "url(#paint13_linear_1_692)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M520.17 181.162H512.19V189.142H520.17V181.162Z",
    fill: "url(#paint14_linear_1_692)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M590.68 209.102H582.7V217.082H590.68V209.102Z",
    fill: "url(#paint15_linear_1_692)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M414.31 246.482V320.062",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M394.8 116.952L365.98 133.592L394.8 150.232L423.62 133.592L394.8 116.952Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M365.98 178.632V133.592L394.8 150.232V195.272L365.98 178.632Z",
    fill: "url(#paint16_linear_1_692)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M423.62 178.632V133.592L394.8 150.232V195.272L423.62 178.632Z",
    fill: "#040919"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M423.62 151.332L394.8 167.972L423.62 184.612L452.44 167.972L423.62 151.332Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M394.8 241.182V167.972L423.62 184.612V257.822L394.8 241.182Z",
    fill: "url(#paint17_linear_1_692)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M452.44 241.182V167.972L423.62 184.612V257.822L452.44 241.182Z",
    fill: "#040919"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M419.01 241.522V218.872L399.4 207.552V230.192L419.01 241.522Z",
    fill: "#040919"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M419.01 219.062V196.422L399.4 185.102V207.742L419.01 219.062Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M411.04 195.072L406.27 192.312",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M394.8 195.272V150.232",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M423.62 256.822V184.612",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M399.4 230.192L419.01 241.522L376.58 266.012L356.97 254.692L399.4 230.192Z",
    fill: "#CFD2D3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M399.4 215.812V230.192L356.97 254.692V240.302L399.4 215.812Z",
    fill: "#040919"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M399.4 230.192L419.01 241.522V227.132L399.4 215.812V230.192Z",
    fill: "#040919"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M394.81 232.842L414.42 244.172V221.522L394.81 210.202V232.842Z",
    fill: "#CFD2D3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M414.42 221.522L394.81 210.202",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M388.4 236.552L408.01 247.872V225.232L388.4 213.902V236.552Z",
    fill: "#CFD2D3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M408.01 225.232L388.4 213.902",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M381.98 240.252L401.59 251.572V228.932L381.98 217.612V240.252Z",
    fill: "#CFD2D3"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M401.59 228.932L381.98 217.612",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M375.57 243.962L395.18 255.282V232.632L375.57 221.312V243.962Z",
    fill: "#CFD2D3"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M395.18 232.632L375.57 221.312",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M369.15 247.662L388.76 258.982V236.342L369.15 225.012V247.662Z",
    fill: "#CFD2D3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M388.76 236.342L369.15 225.012",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M419.01 227.132V241.522L376.58 266.012V251.632L419.01 227.132Z",
    fill: "#040919"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M356.97 254.692L376.58 266.012V243.372L356.97 232.052V254.692Z",
    fill: "url(#paint18_linear_1_692)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M195.26 120.052L285.06 171.902L304.67 160.582L214.87 108.732C201.3 100.892 182.55 96.0522 161.84 96.0522C120.42 96.0522 86.84 115.432 86.84 139.352C86.84 151.312 95.24 162.132 108.81 169.972L198.61 221.822L218.22 210.502L128.42 158.652C119.87 153.712 114.58 146.892 114.58 139.352C114.58 124.282 135.74 112.062 161.84 112.062C174.89 112.062 186.71 115.112 195.26 120.052Z",
    fill: "#040919"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M195.26 134.442L285.06 186.292L304.67 174.972L214.87 123.122C201.3 115.282 182.55 110.442 161.84 110.442C120.42 110.442 86.84 129.822 86.84 153.742C86.84 165.702 95.24 176.522 108.81 184.362L198.61 236.212L218.22 224.892L128.42 173.042C119.87 168.102 114.58 161.282 114.58 153.742C114.58 138.672 135.74 126.452 161.84 126.452C174.89 126.452 186.71 129.502 195.26 134.442Z",
    fill: "#040919"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M153.61 104.212L148.8 88.4922V111.132L153.61 126.852V104.212Z",
    fill: "#CFD2D3"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M145.63 105.432L136.18 90.4323V113.082L145.63 128.082V105.432Z",
    fill: "#CFD2D3"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M138.16 107.452L124.34 93.6322V116.272L138.16 130.102V107.452Z",
    fill: "#CFD2D3"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M131.4 110.192L113.63 97.9622V120.602L131.4 132.832V110.192Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M125.57 113.552L104.39 103.292V125.942L125.57 136.202V113.552Z",
    fill: "#CFD2D3"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M120.83 117.462L96.89 109.482V132.122L120.83 140.102V117.462Z",
    fill: "#CFD2D3"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M117.33 121.772L91.36 116.312V138.962L117.33 144.422V121.772Z",
    fill: "#CFD2D3"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M115.21 126.382L87.99 123.602V146.252L115.21 149.022V126.382Z",
    fill: "#CFD2D3"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M114.49 131.122H86.84V153.762H114.49V131.122Z",
    fill: "#CFD2D3"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M115.21 135.872L87.99 138.642V161.282L115.21 158.512V135.872Z",
    fill: "#CFD2D3"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M117.33 140.472L91.36 145.932V168.572L117.33 163.122V140.472Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M120.83 144.792L96.89 152.772V175.412L120.83 167.432V144.792Z",
    fill: "#CFD2D3"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M125.57 148.692L104.39 158.952V181.592L125.57 171.332V148.692Z",
    fill: "#CFD2D3"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M153.61 104.212L148.8 88.4922",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M145.63 105.432L136.18 90.4323",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M138.16 107.452L124.34 93.6322",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M131.4 110.192L113.63 97.9622",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M125.57 113.552L104.39 103.292",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M120.83 117.462L96.89 109.482",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M117.33 121.772L91.36 116.312",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M115.21 126.382L87.99 123.602",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M114.49 131.122H86.84",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M115.21 135.872L87.99 138.642",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M117.33 140.472L91.36 145.932",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M120.83 144.792L96.89 152.772",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M125.57 148.692L104.39 158.952",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M233.84 121.792L214.23 133.112V110.462L233.84 99.1422V121.792Z",
    fill: "#CFD2D3"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M214.23 110.462L233.84 99.1422",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M226.32 92.6422L206.71 103.962V81.3123L226.32 69.9922V92.6422Z",
    fill: "#CFD2D3"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M206.71 81.3123L226.32 69.9922",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M226.32 23.8522L206.71 35.1722V12.5322L226.32 1.21216V23.8522Z",
    fill: "#CFD2D3"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M206.71 12.5322L226.32 1.21216",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M239.52 137.342L219.91 148.662V126.022L239.52 114.702V137.342Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M219.91 126.022L239.52 114.702",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M245.93 141.052L226.32 152.372V129.722L245.93 118.402V141.052Z",
    fill: "#CFD2D3"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M226.32 129.722L245.93 118.402",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M252.35 144.752L232.74 156.072V133.432L252.35 122.102V144.752Z",
    fill: "#CFD2D3"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M232.74 133.432L252.35 122.102",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M258.76 148.452L239.15 159.772V137.132L258.76 125.812V148.452Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M239.15 137.132L258.76 125.812",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M265.18 152.162L245.57 163.482V140.832L265.18 129.512V152.162Z",
    fill: "#CFD2D3"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M245.57 140.832L265.18 129.512",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M271.59 155.862L251.98 167.182V144.542L271.59 133.212V155.862Z",
    fill: "#CFD2D3"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M251.98 144.542L271.59 133.212",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M278.01 159.562L258.39 170.892V148.242L278.01 136.922V159.562Z",
    fill: "#CFD2D3"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M258.39 148.242L278.01 136.922",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M284.42 163.272L264.81 174.592V151.942L284.42 140.622V163.272Z",
    fill: "#CFD2D3"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M264.81 151.942L284.42 140.622",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M290.83 166.972L271.22 178.292V155.652L290.83 144.332V166.972Z",
    fill: "#CFD2D3"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M271.22 155.652L290.83 144.332",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M285.06 171.892L195.26 120.042C186.71 115.102 174.89 112.052 161.84 112.052C135.74 112.052 114.58 124.272 114.58 139.342C114.58 141.832 115.17 144.242 116.25 146.532C121.72 134.952 140.05 126.442 161.84 126.442C174.89 126.442 186.71 129.492 195.26 134.432L285.06 186.282L304.67 174.962L292.21 167.772L285.06 171.902V171.892Z",
    fill: "url(#paint19_linear_1_692)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M131.77 174.962L112.16 186.282V163.642L131.77 152.312V174.962Z",
    fill: "#CFD2D3"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M112.16 163.642L131.77 152.312",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M138.18 178.662L118.57 189.982V167.342L138.18 156.022V178.662Z",
    fill: "#CFD2D3"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M118.57 167.342L138.18 156.022",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M144.6 182.372L124.99 193.692V171.042L144.6 159.722V182.372Z",
    fill: "#CFD2D3"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M124.99 171.042L144.6 159.722",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M151.01 186.072L131.4 197.392V174.752L151.01 163.422V186.072Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M131.4 174.752L151.01 163.422",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M157.43 189.772L137.82 201.092V178.452L157.43 167.132V189.772Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M137.82 178.452L157.43 167.132",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M163.84 193.482L144.23 204.802V182.152L163.84 170.832V193.482Z",
    fill: "#CFD2D3"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M144.23 182.152L163.84 170.832",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M170.26 197.182L150.65 208.502V185.862L170.26 174.532V197.182Z",
    fill: "#CFD2D3"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M150.65 185.862L170.26 174.532",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M176.67 200.882L157.06 212.212V189.562L176.67 178.242V200.882Z",
    fill: "#CFD2D3"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M157.06 189.562L176.67 178.242",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M183.09 204.592L163.48 215.912V193.262L183.09 181.942V204.592Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M163.48 193.262L183.09 181.942",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M189.5 208.292L169.89 219.612V196.972L189.5 185.652V208.292Z",
    fill: "#CFD2D3"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M169.89 196.972L189.5 185.652",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M195.92 211.992L176.31 223.322V200.672L195.92 189.352V211.992Z",
    fill: "#CFD2D3"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M176.31 200.672L195.92 189.352",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M202.33 215.702L182.72 227.022V204.372L202.33 193.052V215.702Z",
    fill: "#CFD2D3"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M182.72 204.372L202.33 193.052",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M205.76 217.682L198.61 221.812L108.81 169.962C98.02 163.732 90.52 155.612 87.89 146.542C87 143.132 86.84 139.352 86.84 139.352V153.742C86.84 165.702 95.24 176.522 108.81 184.362L198.61 236.212L218.22 224.892L205.76 217.702V217.682Z",
    fill: "#083B4A"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M317.74 476.356C320.834 478.142 324.646 478.142 327.74 476.356L481.26 387.732L322.74 296.212L179.23 379.072C172.563 382.921 172.564 392.543 179.23 396.392L317.74 476.356Z",
    fill: "url(#paint20_linear_1_692)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M322.74 306.622L472.24 392.932L481.26 387.732L322.74 296.212L168.733 385.132C166.732 386.287 166.733 389.176 168.735 390.329L173.25 392.932L322.74 306.622Z",
    fill: "#D0D3F5"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M322.74 325.532L455.87 402.382L472.24 392.932L322.74 306.622L173.25 392.932L189.62 402.382L322.74 325.532Z",
    fill: "#040919"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M322.74 296.212V306.622L173.25 392.932L168.735 390.329C166.733 389.176 166.732 386.287 168.733 385.132L322.74 296.212Z",
    fill: "#040919"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M322.74 306.622L173.25 392.932",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M345.04 319.472V317.512C345.04 315.292 346.61 312.572 348.53 311.462L358.53 305.692C360.45 304.582 360.45 302.772 358.53 301.662L335.55 288.392C333.63 287.282 332.06 284.562 332.06 282.342V154.262",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M345.04 319.472V342.902",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M349.36 370.522H341.38V378.502H349.36V370.522Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M349.36 362.542H341.38V370.522H349.36V362.542Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M341.38 362.542H333.4V370.522H341.38V362.542Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M264.88 414.652H256.9V422.632H264.88V414.652Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M264.88 406.672H256.9V414.652H264.88V406.672Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M264.88 398.692H256.9V406.672H264.88V398.692Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M349.36 437.162H341.38V445.142H349.36V437.162Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M272.86 422.632H264.88V430.612H272.86",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M272.86 414.652H264.88V422.632H272.86V414.652Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M308.33 142.002L279.51 158.632L308.33 175.272L337.15 158.632L308.33 142.002Z",
    fill: "#040919"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M279.51 198.042V158.632L308.33 175.272V214.682L279.51 198.042Z",
    fill: "#083B4A"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M337.15 198.042V158.632L308.33 175.272V214.682L337.15 198.042Z",
    fill: "#040919"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M308.33 213.682V175.272",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M286.33 176.022C286.717 176.022 287.03 175.709 287.03 175.322C287.03 174.936 286.717 174.622 286.33 174.622C285.943 174.622 285.63 174.936 285.63 175.322C285.63 175.709 285.943 176.022 286.33 176.022Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M294.37 180.672C294.757 180.672 295.07 180.359 295.07 179.972C295.07 179.586 294.757 179.272 294.37 179.272C293.983 179.272 293.67 179.586 293.67 179.972C293.67 180.359 293.983 180.672 294.37 180.672Z",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M286.33 185.312C286.717 185.312 287.03 184.999 287.03 184.612C287.03 184.226 286.717 183.912 286.33 183.912C285.943 183.912 285.63 184.226 285.63 184.612C285.63 184.999 285.943 185.312 286.33 185.312Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M302.41 185.312C302.797 185.312 303.11 184.999 303.11 184.612C303.11 184.226 302.797 183.912 302.41 183.912C302.023 183.912 301.71 184.226 301.71 184.612C301.71 184.999 302.023 185.312 302.41 185.312Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M294.37 189.952C294.757 189.952 295.07 189.639 295.07 189.252C295.07 188.866 294.757 188.552 294.37 188.552C293.983 188.552 293.67 188.866 293.67 189.252C293.67 189.639 293.983 189.952 294.37 189.952Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M286.33 194.592C286.717 194.592 287.03 194.279 287.03 193.892C287.03 193.506 286.717 193.192 286.33 193.192C285.943 193.192 285.63 193.506 285.63 193.892C285.63 194.279 285.943 194.592 286.33 194.592Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M302.41 194.592C302.797 194.592 303.11 194.279 303.11 193.892C303.11 193.506 302.797 193.192 302.41 193.192C302.023 193.192 301.71 193.506 301.71 193.892C301.71 194.279 302.023 194.592 302.41 194.592Z",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M302.41 203.882C302.797 203.882 303.11 203.569 303.11 203.182C303.11 202.796 302.797 202.482 302.41 202.482C302.023 202.482 301.71 202.796 301.71 203.182C301.71 203.569 302.023 203.882 302.41 203.882Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M294.37 199.242C294.757 199.242 295.07 198.929 295.07 198.542C295.07 198.156 294.757 197.842 294.37 197.842C293.983 197.842 293.67 198.156 293.67 198.542C293.67 198.929 293.983 199.242 294.37 199.242Z",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M308.33 246.562L279.51 263.202L308.33 279.842L337.15 263.202L308.33 246.562Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M279.51 330.482V263.202L308.33 279.842V347.122L279.51 330.482Z",
    fill: "#083B4A"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M337.15 330.482V263.202L308.33 279.842V347.122L337.15 330.482Z",
    fill: "#040919"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M308.33 416.872L337.15 400.232L308.33 383.602",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M308.33 416.872V457.742L279.51 441.102V424.632",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M337.15 441.102V400.232L308.33 416.872V457.742L337.15 441.102Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M308.33 416.872L300.64 412.432",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M279.51 350.482L250.69 367.122L279.51 383.762L308.33 367.122L279.51 350.482Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M250.69 407.992V367.122L279.51 383.762V424.632L250.69 407.992Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M308.33 407.992V367.122L279.51 383.762V424.632L308.33 407.992Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M279.51 309.622L250.69 326.262L279.51 342.902L308.33 326.262L279.51 309.622Z",
    fill: "white"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M250.69 367.122V326.262L279.51 342.902V383.762L250.69 367.122Z",
    fill: "#083B4A"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M308.33 367.122V326.262L279.51 342.902V383.762L308.33 367.122Z",
    fill: "#040919"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M250.69 352.832L221.87 369.472L250.69 386.112L279.51 369.472L250.69 352.832Z",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M221.87 383.762V369.472L250.69 386.112V400.402L221.87 383.762Z",
    fill: "#083B4A"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M279.51 383.762V369.472L250.69 386.112V400.402L279.51 383.762Z",
    fill: "#040919"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M423.62 288.222L394.8 304.852L423.62 321.492L452.44 304.852L423.62 288.222Z",
    fill: "#083B4A"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M394.8 358.062V304.852L423.62 321.492V374.702L394.8 358.062Z",
    fill: "#4331E8"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M452.44 358.062V304.852L423.62 321.492V374.702L452.44 358.062Z",
    fill: "#040919"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M221.87 165.312L193.05 181.952L221.87 198.592L250.69 181.952L221.87 165.312Z",
    fill: "#083B4A"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M193.05 299.652V181.952L221.87 198.592V316.292L193.05 299.652Z",
    fill: "url(#paint21_linear_1_692)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M250.69 299.652V181.952L221.87 198.592V316.292L250.69 299.652Z",
    fill: "#040919"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M221.87 315.292V198.592",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M244.32 266.832C244.707 266.832 245.02 266.519 245.02 266.132C245.02 265.746 244.707 265.432 244.32 265.432C243.933 265.432 243.62 265.746 243.62 266.132C243.62 266.519 243.933 266.832 244.32 266.832Z",
    fill: "white"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M236.28 271.482C236.667 271.482 236.98 271.169 236.98 270.782C236.98 270.396 236.667 270.082 236.28 270.082C235.893 270.082 235.58 270.396 235.58 270.782C235.58 271.169 235.893 271.482 236.28 271.482Z",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M244.32 276.122C244.707 276.122 245.02 275.809 245.02 275.422C245.02 275.036 244.707 274.722 244.32 274.722C243.933 274.722 243.62 275.036 243.62 275.422C243.62 275.809 243.933 276.122 244.32 276.122Z",
    fill: "white"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M228.24 276.122C228.627 276.122 228.94 275.809 228.94 275.422C228.94 275.036 228.627 274.722 228.24 274.722C227.853 274.722 227.54 275.036 227.54 275.422C227.54 275.809 227.853 276.122 228.24 276.122Z",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M236.28 280.762C236.667 280.762 236.98 280.449 236.98 280.062C236.98 279.676 236.667 279.362 236.28 279.362C235.893 279.362 235.58 279.676 235.58 280.062C235.58 280.449 235.893 280.762 236.28 280.762Z",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M244.32 285.402C244.707 285.402 245.02 285.089 245.02 284.702C245.02 284.316 244.707 284.002 244.32 284.002C243.933 284.002 243.62 284.316 243.62 284.702C243.62 285.089 243.933 285.402 244.32 285.402Z",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M228.24 285.402C228.627 285.402 228.94 285.089 228.94 284.702C228.94 284.316 228.627 284.002 228.24 284.002C227.853 284.002 227.54 284.316 227.54 284.702C227.54 285.089 227.853 285.402 228.24 285.402Z",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M236.28 290.052C236.667 290.052 236.98 289.739 236.98 289.352C236.98 288.966 236.667 288.652 236.28 288.652C235.893 288.652 235.58 288.966 235.58 289.352C235.58 289.739 235.893 290.052 236.28 290.052Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M244.32 294.692C244.707 294.692 245.02 294.379 245.02 293.992C245.02 293.606 244.707 293.292 244.32 293.292C243.933 293.292 243.62 293.606 243.62 293.992C243.62 294.379 243.933 294.692 244.32 294.692Z",
    fill: "white"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M228.24 294.692C228.627 294.692 228.94 294.379 228.94 293.992C228.94 293.606 228.627 293.292 228.24 293.292C227.853 293.292 227.54 293.606 227.54 293.992C227.54 294.379 227.853 294.692 228.24 294.692Z",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M228.24 303.972C228.627 303.972 228.94 303.659 228.94 303.272C228.94 302.885 228.627 302.572 228.24 302.572C227.853 302.572 227.54 302.885 227.54 303.272C227.54 303.659 227.853 303.972 228.24 303.972Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M236.28 299.332C236.667 299.332 236.98 299.019 236.98 298.632C236.98 298.246 236.667 297.932 236.28 297.932C235.893 297.932 235.58 298.246 235.58 298.632C235.58 299.019 235.893 299.332 236.28 299.332Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M394.8 286.762L365.98 303.402L394.8 320.042L423.62 303.402L394.8 286.762Z",
    fill: "#040919"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M365.98 433.682V303.402L394.8 320.042V437.642L383.87 444.012L365.98 433.682Z",
    fill: "url(#paint22_linear_1_692)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M423.62 421.012V303.402L394.8 320.042V437.642L423.62 421.012Z",
    fill: "#040919"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M394.8 436.642V320.042L423.13 303.682",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M365.98 433.682L383.85 444.002",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M372.34 399.502C372.727 399.502 373.04 399.189 373.04 398.802C373.04 398.416 372.727 398.102 372.34 398.102C371.953 398.102 371.64 398.416 371.64 398.802C371.64 399.189 371.953 399.502 372.34 399.502Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M380.39 404.152C380.777 404.152 381.09 403.839 381.09 403.452C381.09 403.066 380.777 402.752 380.39 402.752C380.003 402.752 379.69 403.066 379.69 403.452C379.69 403.839 380.003 404.152 380.39 404.152Z",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M372.34 408.792C372.727 408.792 373.04 408.479 373.04 408.092C373.04 407.706 372.727 407.392 372.34 407.392C371.953 407.392 371.64 407.706 371.64 408.092C371.64 408.479 371.953 408.792 372.34 408.792Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M388.43 408.792C388.817 408.792 389.13 408.479 389.13 408.092C389.13 407.706 388.817 407.392 388.43 407.392C388.043 407.392 387.73 407.706 387.73 408.092C387.73 408.479 388.043 408.792 388.43 408.792Z",
    fill: "white"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M380.39 413.432C380.777 413.432 381.09 413.119 381.09 412.732C381.09 412.346 380.777 412.032 380.39 412.032C380.003 412.032 379.69 412.346 379.69 412.732C379.69 413.119 380.003 413.432 380.39 413.432Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M372.34 418.072C372.727 418.072 373.04 417.759 373.04 417.372C373.04 416.986 372.727 416.672 372.34 416.672C371.953 416.672 371.64 416.986 371.64 417.372C371.64 417.759 371.953 418.072 372.34 418.072Z",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M388.43 418.072C388.817 418.072 389.13 417.759 389.13 417.372C389.13 416.986 388.817 416.672 388.43 416.672C388.043 416.672 387.73 416.986 387.73 417.372C387.73 417.759 388.043 418.072 388.43 418.072Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M380.39 422.722C380.777 422.722 381.09 422.409 381.09 422.022C381.09 421.635 380.777 421.322 380.39 421.322C380.003 421.322 379.69 421.635 379.69 422.022C379.69 422.409 380.003 422.722 380.39 422.722Z",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M372.34 427.362C372.727 427.362 373.04 427.049 373.04 426.662C373.04 426.276 372.727 425.962 372.34 425.962C371.953 425.962 371.64 426.276 371.64 426.662C371.64 427.049 371.953 427.362 372.34 427.362Z",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M388.43 427.362C388.817 427.362 389.13 427.049 389.13 426.662C389.13 426.276 388.817 425.962 388.43 425.962C388.043 425.962 387.73 426.276 387.73 426.662C387.73 427.049 388.043 427.362 388.43 427.362Z",
    fill: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M388.43 436.642C388.817 436.642 389.13 436.329 389.13 435.942C389.13 435.556 388.817 435.242 388.43 435.242C388.043 435.242 387.73 435.556 387.73 435.942C387.73 436.329 388.043 436.642 388.43 436.642Z",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M380.39 432.002C380.777 432.002 381.09 431.689 381.09 431.302C381.09 430.916 380.777 430.602 380.39 430.602C380.003 430.602 379.69 430.916 379.69 431.302C379.69 431.689 380.003 432.002 380.39 432.002Z",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M308.33 347.122V279.842",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M279.51 383.762V342.902",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M250.69 400.402V386.112",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M221.87 383.762L250.69 400.402L308.33 367.122",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M399.19 351.692V329.052L418.8 317.732V340.372L399.19 351.692Z",
    fill: "#040919"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M399.19 374.342V337.379L418.8 340.372V363.012L399.19 374.342Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M399.19 396.982V374.342L418.8 363.012V385.662L399.19 396.982Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M418.8 340.372L399.19 351.692L489 403.542L508.61 392.222L418.8 340.372Z",
    fill: "#040919"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M418.8 325.982V340.372L508.61 392.222V377.832L418.8 325.982Z",
    fill: "#040919"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M418.8 340.372L399.19 351.692V337.312L418.8 325.982V340.372Z",
    fill: "#CFD2D3"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M424.11 343.442L404.5 354.762V332.112L424.11 320.792V343.442Z",
    fill: "#CFD2D3"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5 332.112L424.11 320.792",
    stroke: "#DF5F36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M430.53 347.142L410.92 358.462V335.822L430.53 324.492V347.142Z",
    fill: "#CFD2D3"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M410.92 335.822L430.53 324.492",
    stroke: "#DF5F36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M436.94 350.842L417.33 362.162V339.522L436.94 328.202V350.842Z",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M417.33 339.522L436.94 328.202",
    stroke: "#DF5F36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M443.36 354.552L423.75 365.872V343.222L443.36 331.902V354.552Z",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M423.75 343.222L443.36 331.902",
    stroke: "#DF5F36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M449.77 358.252L430.16 369.572V346.932L449.77 335.602V358.252Z",
    fill: "#CFD2D3"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M430.16 346.932L449.77 335.602",
    stroke: "#DF5F36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M456.19 361.952L436.58 373.272V350.632L456.19 339.312V361.952Z",
    fill: "#CFD2D3"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M436.58 350.632L456.19 339.312",
    stroke: "#DF5F36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M462.6 365.662L442.99 376.982V354.332L462.6 343.012V365.662Z",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M442.99 354.332L462.6 343.012",
    stroke: "#DF5F36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M469.02 369.362L449.4 380.682V358.042L469.02 346.722V369.362Z",
    fill: "#CFD2D3"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M449.4 358.042L469.02 346.722",
    stroke: "#DF5F36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M493.75 364.122L474.14 375.442V352.802L493.75 341.482V364.122Z",
    fill: "#CFD2D3"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M474.14 352.802L493.75 341.482",
    stroke: "#DF5F36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M399.19 337.312V351.692L489 403.542V389.152L399.19 337.312Z",
    fill: "url(#paint23_linear_1_692)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M508.61 392.222L489 403.542V380.902L508.61 369.572V392.222Z",
    fill: "url(#paint24_linear_1_692)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M407.17 373.182L411.94 370.422",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M399.19 419.632V396.982L418.8 385.662V408.302L399.19 419.632Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M407.17 395.822L411.94 393.072",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M312.94 338.482V315.832L332.55 304.512V327.162L312.94 338.482Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M320.91 314.672L325.68 311.922",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M312.94 315.832V293.192L332.55 281.872V304.512L312.94 315.832Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M320.91 292.032L325.68 289.282",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M333.4 437.162H325.42V445.142H333.4V437.162Z",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M333.4 445.142H325.42V453.122H333.4V445.142Z",
    fill: "white"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M325.42 453.122H317.44V461.102H325.42V453.122Z",
    fill: "white"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M228.24 303.272L229.81 304.182C231.76 305.312 233.36 308.072 233.36 310.332V350.362",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M289.25 257.572V316.992C289.25 319.382 287.56 322.312 285.49 323.512L277.5 328.122C275.43 329.312 275.43 331.272 277.5 332.462L288.05 338.552C290.12 339.742 291.81 342.682 291.81 345.072V382.552",
    stroke: "#DF5F36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M294.37 198.542L292.74 199.482C290.82 200.592 289.25 203.312 289.25 205.532V257.572",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M233.36 350.362V427.462",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M316.69 128.892V148.722C316.69 150.922 315.13 153.632 313.22 154.732L311.18 155.912C309.66 156.792 309.66 158.222 311.18 159.102C312.7 159.982 315.18 159.982 316.7 159.102L328.56 152.252C330.48 151.142 332.05 152.052 332.05 154.272",
    stroke: "#083B4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M308.33 21.3522L279.51 37.9922L308.33 54.6322L337.15 37.9922L308.33 21.3522Z",
    fill: "#083B4A"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M279.51 120.362V37.9922L308.33 54.6322V137.002L279.51 120.362Z",
    fill: "url(#paint25_linear_1_692)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M337.15 120.362V37.9922L308.33 54.6322V137.002L337.15 120.362Z",
    fill: "#040919"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M308.33 136.002V54.6322",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M303.73 128.892V106.242L284.12 94.9222V117.572L303.73 128.892Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M295.75 105.082L290.98 102.332",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M303.73 106.242V83.6022L284.12 72.2822V94.9222L303.73 106.242Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M295.75 82.4423L290.98 79.6923",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M345.04 343.992C346.078 343.992 346.92 343.504 346.92 342.902C346.92 342.3 346.078 341.812 345.04 341.812C344.002 341.812 343.16 342.3 343.16 342.902C343.16 343.504 344.002 343.992 345.04 343.992Z",
    fill: "white"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M291.81 383.642C292.848 383.642 293.69 383.154 293.69 382.552C293.69 381.95 292.848 381.462 291.81 381.462C290.772 381.462 289.93 381.95 289.93 382.552C289.93 383.154 290.772 383.642 291.81 383.642Z",
    fill: "white"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M112.43 500.132L145.2 519.052L187.88 494.422V423.722L207.46 412.422",
    stroke: "#DF5F36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1899 520.612L151.83 476.942L76.1899 433.272L0.549927 476.942L76.1899 520.612Z",
    fill: "url(#paint26_linear_1_692)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1899 442.242L144.06 481.432L151.83 476.942L76.1899 433.272L0.549927 476.942L8.31989 481.432L76.1899 442.242Z",
    fill: "#CFD2D3"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1899 451.262L136.25 485.942L144.06 481.432L76.1899 442.242L8.31989 481.432L16.1299 485.942L76.1899 451.262Z",
    fill: "#040919"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1899 433.272V442.242L8.31989 481.432L0.549927 476.942L76.1899 433.272Z",
    fill: "#040919"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1899 442.242L8.31989 481.432",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3399 486.312H68.3599V494.292H76.3399V486.312Z",
    fill: "#040919"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3399 494.292H68.3599V502.272H76.3399V494.292Z",
    fill: "#040919"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M118.74 475.232H110.76V483.212H118.74V475.232Z",
    fill: "#040919"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4699 499.182V507.162H99.4999L104.45 504.302V499.182H96.4699Z",
    fill: "#040919"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3599 494.292H60.3799V502.272H68.3599V494.292Z",
    fill: "#040919"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3999 494.292H44.4199V502.272H52.3999",
    fill: "#040919"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3999 502.272H44.4199L52.3999 506.882",
    fill: "#040919"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M104.91 448.202L74.3899 345.962C74.1499 345.162 73.7999 344.472 73.3599 343.892L73.4099 341.732H69.1199C68.0999 341.732 67.0299 342.022 65.9799 342.622L34.2599 360.932C30.7799 362.942 28.8799 367.732 30.0299 371.572L60.5499 473.812C61.3499 476.502 63.4399 478.042 65.8199 478.042H70.1099L70.1499 476.472L100.68 458.842C104.16 456.832 106.06 452.042 104.91 448.202Z",
    fill: "url(#paint27_linear_1_692)",
    stroke: "url(#paint28_linear_1_692)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5499 360.922C35.0699 362.932 33.1699 367.722 34.3199 371.562L64.8399 473.802C65.9899 477.652 69.7699 479.152 73.2499 477.142L104.97 458.832C108.45 456.822 110.35 452.032 109.2 448.192L78.6799 345.952C77.5299 342.102 73.7499 340.602 70.2699 342.612L38.5499 360.922Z",
    fill: "url(#paint29_linear_1_692)",
    stroke: "url(#paint30_linear_1_692)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1599 444.732L64.8399 473.802C65.9899 477.652 69.7699 479.152 73.2499 477.142L104.97 458.832C107.15 457.572 109.03 455.142 109.35 452.412",
    stroke: "url(#paint31_linear_1_692)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5999 457.962L97.2799 456.402L96.3199 453.172L93.6399 454.742L94.5999 457.962Z",
    fill: "url(#paint32_linear_1_692)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1799 465.312L90.5399 462.172L88.6099 455.722L83.2499 458.862L85.1799 465.312Z",
    fill: "white"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5999 457.962L97.2799 456.402L96.3199 453.172L93.6399 454.742L94.5999 457.962Z",
    fill: "white"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M101.9 453.752L104.58 452.182L103.61 448.962L100.94 450.532L101.9 453.752Z",
    fill: "white"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4299 467.892L80.1099 466.322L79.1399 463.102L76.4599 464.672L77.4299 467.892Z",
    fill: "white"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1299 472.102L72.8099 470.532L71.8499 467.312L69.1699 468.882L70.1299 472.102Z",
    fill: "white"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5599 370.362L40.4799 373.292",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5299 373.202L41.4599 376.142",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4399 398.422C89.3799 400.362 82.8199 393.752 80.0199 394.882C77.5599 395.872 79.4499 399.552 76.2199 400.892C73.2999 402.102 67.0799 388.062 63.3199 390.072C59.5599 392.082 64.6999 412.552 60.7499 414.832C56.7999 417.102 50.5899 406.502 47.0999 408.652",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7399 424.102L59.9899 433.192",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4699 429.642L61.1399 436.182",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2999 472.102L92.2299 475.232C92.9499 477.652 93.5399 481.692 93.5399 484.212V509.952",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1299 469.142L88.7099 473.592L93.1499 471.042L91.7199 466.492L87.1299 469.142Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_692",
    x1: 567.542,
    y1: 273.77,
    x2: 567.542,
    y2: 186.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000928297,
    stopColor: "#CFD2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_692",
    x1: 547.58,
    y1: 165.452,
    x2: 547.58,
    y2: 235.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF5F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF5F36",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_692",
    x1: 548.465,
    y1: 168.752,
    x2: 548.465,
    y2: 174.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF5F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF5F36",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_692",
    x1: 552.02,
    y1: 172.232,
    x2: 552.02,
    y2: 173.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF5F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF5F36",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_692",
    x1: 557.8,
    y1: 167.692,
    x2: 557.8,
    y2: 173.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF5F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF5F36",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_692",
    x1: 563.235,
    y1: 168.522,
    x2: 563.235,
    y2: 188.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF5F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF5F36",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_692",
    x1: 578.01,
    y1: 184.522,
    x2: 578.01,
    y2: 190.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF5F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF5F36",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_692",
    x1: 575.995,
    y1: 187.867,
    x2: 575.995,
    y2: 190.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF5F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF5F36",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_692",
    x1: 569.505,
    y1: 183.062,
    x2: 569.505,
    y2: 185.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF5F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF5F36",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_692",
    x1: 589.995,
    y1: 198.742,
    x2: 589.995,
    y2: 231.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF5F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF5F36",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_692",
    x1: 592.25,
    y1: 156.952,
    x2: 592.25,
    y2: 208.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF5F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF5F36",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_692",
    x1: 543.82,
    y1: 234.812,
    x2: 543.82,
    y2: 242.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF5F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF5F36",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_692",
    x1: 540.55,
    y1: 190.512,
    x2: 540.55,
    y2: 198.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF5F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF5F36",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_692",
    x1: 605.6,
    y1: 139.756,
    x2: 622.525,
    y2: 204.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF5F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF5F36",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_692",
    x1: 512.19,
    y1: 167.806,
    x2: 529.115,
    y2: 232.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF5F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF5F36",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1_692",
    x1: 586.69,
    y1: 209.102,
    x2: 586.69,
    y2: 217.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF5F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF5F36",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1_692",
    x1: 380.39,
    y1: 133.592,
    x2: 380.39,
    y2: 195.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF5F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1_692",
    x1: 409.21,
    y1: 167.972,
    x2: 409.21,
    y2: 257.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF5F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1_692",
    x1: 366.775,
    y1: 232.052,
    x2: 366.775,
    y2: 266.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF5F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1_692",
    x1: 45.8427,
    y1: 163.207,
    x2: 48.0806,
    y2: 116.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#083B4A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1_692",
    x1: 83.5969,
    y1: 321.447,
    x2: 613.941,
    y2: 338.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.205555
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294852,
    stopColor: "#DF5F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464689
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566432,
    stopColor: "#DF5F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.740227
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1_692",
    x1: 182.628,
    y1: 274.532,
    x2: 219.281,
    y2: 209.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#083B4A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1_692",
    x1: 355.559,
    y1: 400.303,
    x2: 394.8,
    y2: 334.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF5F36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1_692",
    x1: 444.095,
    y1: 337.312,
    x2: 444.095,
    y2: 403.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF5F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1_692",
    x1: 498.805,
    y1: 369.572,
    x2: 498.805,
    y2: 403.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF5F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1_692",
    x1: 269.089,
    y1: 106.224,
    x2: 291.491,
    y2: 52.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#083B4A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1_692",
    x1: -37.9265,
    y1: 445.314,
    x2: 215.142,
    y2: 453.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.205555
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294852,
    stopColor: "#DF5F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464689
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566432,
    stopColor: "#DF5F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.740227
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1_692",
    x1: 100.596,
    y1: 286.172,
    x2: 32.5762,
    y2: 579.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF5F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1_692",
    x1: 57.0699,
    y1: 231.763,
    x2: 29.6941,
    y2: 558.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF5F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1_692",
    x1: 70.1371,
    y1: 483.056,
    x2: 73.4765,
    y2: 333.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324632,
    stopColor: "#8A3B21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#DF5F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651568,
    stopColor: "#A64728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1_692",
    x1: 79.7728,
    y1: 285.807,
    x2: 21.6661,
    y2: 537.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF5F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1_692",
    x1: 114.437,
    y1: 386.309,
    x2: 68.3011,
    y2: 565.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF5F36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1_692",
    x1: 95.4599,
    y1: 453.172,
    x2: 95.4599,
    y2: 457.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF5F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenariosIntroduction);
export default __webpack_public_path__ + "static/media/scenarios-introduction.4b9aacd0fd758766be3fc359908c4230.svg";
export { ForwardRef as ReactComponent };